import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { BaseHTTP } from '../api/base.http'
import { UserAuth } from '../context/AuthContext'
import { clearSupportSession, startSupportSession } from '../utils/authSession'

const ImpersonationEntry = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setBackendSession } = UserAuth()
  const [hasFailed, setHasFailed] = useState(false)
  const startedRef = useRef(false)

  useEffect(() => {
    const code = searchParams.get('code')
    if (!code || startedRef.current) return
    startedRef.current = true
    startSupportSession()

    BaseHTTP.getInstance()
      .http.post('v1/auth/impersonation-exchange', { code })
      .then(({ data }) => {
        setBackendSession(
          { token: data.token, registrationStatus: 'COMPLETED' },
          'COMPLETED',
          null
        )
        navigate('/', { replace: true })
      })
      .catch(error => {
        console.error('Error exchanging impersonation code:', error)
        clearSupportSession()
        setHasFailed(true)
      })
  }, [searchParams, setBackendSession, navigate])

  return (
    <div className='flex min-h-screen flex-col items-center justify-center gap-4 text-center'>
      {hasFailed ? (
        <p className='text-lg font-medium text-red-600'>
          No pudimos iniciar la sesión de soporte. El enlace puede haber expirado, vuelve a
          generarlo desde el panel de administración.
        </p>
      ) : (
        <p className='text-lg font-medium text-gray-700'>Iniciando sesión de soporte…</p>
      )}
    </div>
  )
}

export default ImpersonationEntry
